import React, { Children, ReactNode } from "react";
import { ReactComponent as ApolloIcon } from "@apollo/brand/logos/logotype.svg";
import {
  Box,
  BoxProps,
  Link,
  List,
  ListItem,
  Stack,
  Text,
} from "@chakra-ui/react";
import { Link as GatsbyLink } from "gatsby";

type FooterMenuProps = {
  title: string;
  children: ReactNode;
};

const FooterMenu = ({ title, children }: FooterMenuProps) => (
  <Box fontSize="lg">
    <Text mb={{ base: 2, md: 4 }} fontWeight="semibold">
      {title}
    </Text>
    <List spacing="2">
      {Children.map(children, (child) => (
        <ListItem>{child}</ListItem>
      ))}
    </List>
  </Box>
);

export const Footer = (props: BoxProps) => (
  <Box as="footer" borderTopWidth="1px" w="full" bg="bg">
    <Box
      display={{ md: "flex" }}
      mx="auto"
      maxW="container.xl"
      px={[6, 8, 10, 12]}
      py="12"
      {...props}
    >
      <Box mr="8" mb="8">
        <Box
          mb="4"
          as={ApolloIcon}
          h="8"
          fill="current"
          role="img"
          aria-label="Apollo logo"
        />
        <Text>
          &copy; {new Date().getFullYear()} Apollo Graph Inc., d/b/a Apollo
          GraphQL.
        </Text>
      </Box>
      <Stack
        direction={{
          base: "column",
          md: "row",
        }}
        align="flex-start"
        spacing={[6, 8, 10, 12]}
        ml="auto"
      >
        <FooterMenu title="Odyssey">
          <Link as={GatsbyLink} to="/">
            Home
          </Link>
          <Link as={GatsbyLink} to="/lift-off-part1">
            Get started
          </Link>
          <Link href="https://www.apollographql.com/Apollo-Privacy-Policy.pdf">
            Privacy Policy
          </Link>
        </FooterMenu>
        <FooterMenu title="Resources">
          <Link href="https://www.apollographql.com/docs">Docs</Link>
          <Link href="https://www.apollographql.com/blog">Blog</Link>
          <Link href="https://www.apollographql.com/developers">
            Developer Hub
          </Link>
          <Link href="https://community.apollographql.com">Community</Link>
        </FooterMenu>
        <FooterMenu title="Company">
          <Link href="https://www.apollographql.com">About Apollo</Link>
          <Link href="https://studio.apollographql.com">Studio</Link>
          <Link href="https://twitter.com/apollographql">Twitter</Link>
        </FooterMenu>
      </Stack>
    </Box>
  </Box>
);
